import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Decreases the quantity of the given `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{`.
The `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` price is updated as described in `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem-price-selection"
        }}>{`LineItem Price selection`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"removeLineItem"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItem`}</a>{` in the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`quantity`}</inlineCode>{` - Number - Optional
If the quantity is absent or the line item quantity drops to less than `}<inlineCode parentName="li">{`1`}</inlineCode>{`, the line item is removed from the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalPrice`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#money"
          }}>{`Money`}</a>{` - Optional`}<br parentName="li"></br>
          {`Sets the line item `}<inlineCode parentName="li">{`price`}</inlineCode>{` to the given value when decreasing the quantity of a line item with the `}<inlineCode parentName="li">{`ExternalPrice`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitempricemode"
          }}>{`LineItemPriceMode`}</a>{` `}<inlineCode parentName="li">{`priceMode`}</inlineCode>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTotalPrice`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externallineitemtotalprice"
          }}>{`ExternalLineItemTotalPrice`}</a>{` - Optional`}<br parentName="li"></br>
          {`Sets the line item `}<inlineCode parentName="li">{`price`}</inlineCode>{` and `}<inlineCode parentName="li">{`totalPrice`}</inlineCode>{` to the given values when decreasing the quantity of a line item with the `}<inlineCode parentName="li">{`ExternalTotal`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitempricemode"
          }}>{`LineItemPriceMode`}</a>{` `}<inlineCode parentName="li">{`priceMode`}</inlineCode>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingDetailsToRemove`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#itemshippingdetailsdraft"
          }}>{`ItemShippingDetailsDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`Container for line item specific address(es) that are to be removed.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      